import { render, staticRenderFns } from "./All_asset_JGT.vue?vue&type=template&id=36cea1d8&scoped=true&"
import script from "./All_asset_JGT.vue?vue&type=script&lang=js&"
export * from "./All_asset_JGT.vue?vue&type=script&lang=js&"
import style0 from "./All_asset_JGT.vue?vue&type=style&index=0&id=36cea1d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cea1d8",
  null
  
)

export default component.exports